import { render } from "./ProjectEdit.vue?vue&type=template&id=7b256f28&ts=true"
import script from "./ProjectEdit.vue?vue&type=script&lang=ts"
export * from "./ProjectEdit.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__